import currency from 'currency.js';

export const BrazillianCurrency = (value, options = {}) => (
  currency(value, {
    symbol: 'R$ ', decimal: ',', separator: '.', ...options,
  })
);

export default BrazillianCurrency;
